<script>
  export let row;
</script>

<span class="date-value">{row.date}</span>

<style>
  .date-value {
    color: var(--text);
    font-family: var(--font-mo);
    font-size: 13px;
    letter-spacing: 0.5px;
  }
</style>